import { getSupervisionEntry } from "../evidencija/api/getTerapijeModalData";
import { getTtAndTp } from "./api/getTtAndT";
import { getUsersILead } from "./api/getUsersILead";

export const getPolaznikEvidention = async (
  polaznik,
  userIdFromGroup,
  getUsersEvidention,
  authToken,
  setEvidentionData
) => {
  const id = polaznik?.id || userIdFromGroup;
  const eData = await getUsersEvidention(id, authToken);
  setEvidentionData(eData);
};

export const fetchPolaznici = async (
  setPendingRequests,
  role,
  authToken,
  setAllPolaznici
) => {
  setPendingRequests((p) => p + 1);
  try {
    if (role === "Voditelj" || role === "Polaznik VT-a") {
      const polaznici = await getUsersILead(authToken);
      if (Array.isArray(polaznici.groups)) {
        setAllPolaznici(
          polaznici.groups.map((user) => ({
            name: `${user.firstName} ${user.lastName}`,
            id: user.id,
          }))
        );
      }
    } else if (role === "Supervizor") {
      const polaznici = await getTtAndTp(authToken);
      if (Array.isArray(polaznici.userInGroups)) {
        setAllPolaznici(
          polaznici.userInGroups.map((user) => ({
            name: `${user.firstName} ${user.lastName}`,
            id: user.id,
          }))
        );
      }
    } else {
      setAllPolaznici([]);
    }
  } catch (err) {
    console.error(err);
  } finally {
    setPendingRequests((p) => p - 1);
  }
};

export const fetchEvidention = async (
  polaznik,
  setPendingRequests,
  userIdFromGroup,
  getUsersEvidention,
  authToken,
  setEvidentionData
) => {
  if (!polaznik) return;

  setPendingRequests((p) => p + 1);
  try {
    await getPolaznikEvidention(
      polaznik,
      userIdFromGroup,
      getUsersEvidention,
      authToken,
      setEvidentionData
    );
  } finally {
    setPendingRequests((p) => p - 1);
  }
};

export const fetchSupervision = async (
  polaznik,
  setPendingRequests,
  authToken,
  setSupervisionCommentData
) => {
  if (!polaznik) return;

  setPendingRequests((p) => p + 1);
  try {
    const data = await getSupervisionEntry(polaznik.id, authToken);
    setSupervisionCommentData(
      data.sort(
        (a, b) => new Date(b.otherInfo.date) - new Date(a.otherInfo.date)
      )
    );
  } catch {
    console.log("gg");
  } finally {
    setPendingRequests((p) => p - 1);
  }
};
